import { useEffect, useState } from "react";
import "./Profile.scss";
import Menu from "./components/Menu";
import ProfileDetails from "./components/ProfileDetails";
import Orders from "./components/Orders";
import Favourites from "./components/Favourites";
import Addresses from "./components/Addresses";
import PromoCodes from "./components/PromoCodes";
import LogOut from "./components/LogOut";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

export default function Profile({
  user,
  openLogOut,
  setOpenLogOut,
  setUser,
  setOpenBurger,
  cart,
  setCart,
  showMessage,
  setShowMessage,
  showCopyMessage,
  setShowCopyMessage,
  showDeletedMessage,
  setShowDeletedMessage,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cookie] = useCookies(["access_token"]);
  const [active, setActive] = useState(
    window.screen.width > 767 ? "details" : ""
  );
  const [activeHeading, setActiveHeading] = useState("Профил");

  useEffect(() => {
    !cookie?.access_token && navigate("/404");
    setOpenBurger(false);
  }, []);

  useEffect(() => {
    if (window.screen.width < 767 && active !== "") {
      {
        active === "details" && setActiveHeading(`${t("profile-details")}`);
      }
      {
        active === "orders" && setActiveHeading(`${t("orders")}`);
      }
      {
        active === "favourites" && setActiveHeading(`${t("favourites")}`);
      }
      {
        active === "addresses" && setActiveHeading(`${t("addresses")}`);
      }
      {
        active === "promo" && setActiveHeading(`${t("promo-codes")}`);
      }
    }
  }, [active]);

  return (
    <>
      {window.screen.width > 767 && <div className="tree"></div>}
      <div className="profile-wrapper">
        <div className="title">
          {window.screen.width < 767 && active !== "" && (
            <div
              className="back"
              onClick={() => {
                setActive("");
                setActiveHeading(`${t("profile")}`);
              }}
            ></div>
          )}
          {window.screen.width > 767 && <p>{t("profile")}</p>}
          {window.screen.width < 767 && <p>{activeHeading}</p>}
        </div>
        <div className="content">
          {(window.screen.width > 767 ||
            (window.screen.width < 767 && active === "")) && (
            <Menu
              active={active}
              setActive={setActive}
              openLogOut={openLogOut}
              setOpenLogOut={setOpenLogOut}
            ></Menu>
          )}
          <div
            className={active === "" ? "inner-content" : "inner-content active"}
          >
            {active === "details" && (
              <ProfileDetails user={user}></ProfileDetails>
            )}
            {active === "orders" && (
              <Orders cart={cart} setCart={setCart}></Orders>
            )}
            {active === "favourites" && (
              <Favourites
                cart={cart}
                setCart={setCart}
                showMessage={showMessage}
                setShowMessage={setShowMessage}
              ></Favourites>
            )}
            {active === "addresses" && (
              <Addresses
                showDeletedMessage={showDeletedMessage}
                setShowDeletedMessage={setShowDeletedMessage}
              ></Addresses>
            )}
            {active === "promo" && (
              <PromoCodes
                showCopyMessage={showCopyMessage}
                setShowCopyMessage={setShowCopyMessage}
              ></PromoCodes>
            )}
          </div>
        </div>
      </div>
      {openLogOut && (
        <LogOut
          openLogOut={openLogOut}
          setOpenLogOut={setOpenLogOut}
          setUser={setUser}
        ></LogOut>
      )}
    </>
  );
}
